import { sendPost } from "@/utils/request";

export function getFooterContent(params) {
  const url = "/api/website/get";
  return sendPost(url, params, false);
}
